<script setup lang="ts"></script>
<template>
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-10">
        <svg
            width="260"
            height="220"
            viewBox="0 0 260 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="130" cy="110" r="92" fill="#F1F3F5" />

            <ellipse cx="130" cy="198" rx="80" ry="8" fill="#E2E6EA" />

            <path
                d="M50 58 L70 58 L78 78 L80 86"
                stroke="#084298"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
            />

            <path
                d="M78 78 L208 78 L192 142 L96 142 Z"
                fill="white"
                stroke="#084298"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />

            <line
                x1="108"
                y1="92"
                x2="180"
                y2="92"
                stroke="#CED4DA"
                stroke-width="3"
                stroke-linecap="round"
                stroke-dasharray="6 8"
            />
            <line
                x1="112"
                y1="110"
                x2="176"
                y2="110"
                stroke="#CED4DA"
                stroke-width="3"
                stroke-linecap="round"
                stroke-dasharray="6 8"
            />
            <line
                x1="116"
                y1="128"
                x2="172"
                y2="128"
                stroke="#CED4DA"
                stroke-width="3"
                stroke-linecap="round"
                stroke-dasharray="6 8"
            />

            <circle
                cx="112"
                cy="166"
                r="11"
                fill="white"
                stroke="#084298"
                stroke-width="5"
            />
            <circle
                cx="178"
                cy="166"
                r="11"
                fill="white"
                stroke="#084298"
                stroke-width="5"
            />

            <path
                d="M214 46 L214 38 M214 62 L214 70 M206 54 L198 54 M222 54 L230 54"
                stroke="#FD7E14"
                stroke-width="3"
                stroke-linecap="round"
            />
            <path
                d="M48 158 L48 152 M48 170 L48 176 M42 164 L36 164 M54 164 L60 164"
                stroke="#FD7E14"
                stroke-width="3"
                stroke-linecap="round"
                opacity="0.7"
            />

            <circle cx="232" cy="120" r="3" fill="#084298" opacity="0.4" />
            <circle cx="30" cy="92" r="3" fill="#084298" opacity="0.4" />
        </svg>

        <div
            class="tw-w-full md:tw-w-2/3 tw-flex tw-flex-col tw-items-center tw-gap-4 tw-mx-auto"
        >
            <p>
                Es posible que el producto que busca no esté disponible en este
                momento. Por favor, asegúrese de que las palabras estén escritas
                correctamente o pruebe con términos alternativos.
            </p>
            <p>
                Si necesita ayuda, no dude en contactar a nuestro servicio de
                atención al cliente al número
                <a
                    href="tel:+5359868545"
                    class="tw-text-primary tw-cursor-pointer"
                    >+53 5 9868545</a
                >
                y unirse al grupo de WhatsApp de la tienda para estar informado
                de los nuevos productos.
            </p>
            <strong class="tw-text-lg">¡Estamos aquí para ayudarle!</strong>
        </div>
    </div>
</template>
